"use client"

import { useState, useTransition } from "react"
import type { Partner } from "@apps/gwservice/types"
import { PartnerCard } from "./partner-card"
import { SearchFilter } from "~/components/search-filter"

interface Props {
  partners: Partner[]
}

export function PartnersFeed({ partners }: Props) {
  const [query, setQuery] = useState("")
  const [isPending, startTransition] = useTransition()

  const filtered = query
    ? partners.filter(
        (partner) =>
          partner.title.toLowerCase().includes(query.toLowerCase()) ||
          partner.info?.toLowerCase().includes(query.toLowerCase()),
      )
    : partners

  return (
    <div className="flex flex-col">
      <SearchFilter
        value={query}
        onChange={(value) => startTransition(() => setQuery(value))}
        isPending={isPending}
        placeholder="Поиск партнеров..."
      />
      <div className={`flex flex-col gap-s p-m transition-opacity ${isPending ? "opacity-50" : ""}`}>
        {filtered.map((partner) => (
          <PartnerCard key={partner.id} partner={partner} />
        ))}
      </div>
    </div>
  )
}
